export const SUPER_ADMIN = "super-admin"
export const MUNICIPALITY_ADMIN = "municipality-admin"
export const WARD_ADMIN = "ward-admin"
export const OFFICERS = "officers"
